import { addItem, getItems, updateItem, deleteItem } from './db';

let ClientsTable = 'Clients';

export async function saveClients(data) {
    for await (const element of data) {
        await addItem(ClientsTable, element, '_id');
    }
}

export async function getLocalClients() {
    return await getItems(ClientsTable);
}